export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-lg mx-auto text-center">
        <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100">
          <i className="ri-mail-send-line text-2xl text-accent-600"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          联系我们
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8">
          如有影片推荐、内容反馈或合作咨询，欢迎通过以下方式联系我们
        </p>

        <form
          data-readdy-form
          action="https://readdy.ai/api/form/d9mnmqu8mbnljin59ps0"
          method="POST"
          className="flex flex-col gap-4 text-left"
          onSubmit={(e) => { e.preventDefault(); }}
        >
          <input type="text" name="website_alt" className="form-website-alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />

          <div>
            <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">
              您的称呼
            </label>
            <input
              id="contact-name"
              name="name"
              type="text"
              placeholder="请输入您的称呼"
              className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            />
          </div>

          <div>
            <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">
              电子邮箱
            </label>
            <input
              id="contact-email"
              name="email"
              type="email"
              placeholder="请输入您的邮箱地址"
              className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            />
          </div>

          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">
              留言内容
            </label>
            <textarea
              id="contact-message"
              name="message"
              rows={4}
              maxLength={500}
              placeholder="请输入您想说的话（限500字）"
              className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            <i className="ri-send-plane-line mr-2"></i>
            发送留言
          </button>
        </form>
      </div>
    </section>
  );
}